<template>
	<div>
		<div>
			<el-carousel trigger="click" height="500px">
			  <el-carousel-item v-for="(item, index) in images" :key="index">
			    <el-image
			      style="width: 100%; height: 500px"
			      :src="item"
			      fit="fill"
			    ></el-image>
			  </el-carousel-item>
			</el-carousel>
		</div>
		<div style="width: 70%;margin: auto;">
			<p style="width: 421px;margin: 5px auto;border-bottom: 5px solid red;line-height: 30px;">会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕</p>
			<p style="font-size: 14px;text-indent: 2em;">2019年5月26日，第十六期全国激光美容与抗衰老新技术学习班在北京圆满结束，来自全国各地的400多名医疗工作者参加了此次学习。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902071109590.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">此次学习班的授课专家团由杨蓉娅教授、隋志甫副教授、祝贺副教授、魏薇副教授、周双琳副教授、张德全博士、张金侠博士共同组成。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902071121334.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">在为期四天的学习中，行业内一流专家分享了各种新型激光和光子技术的基础及其临床应用，包括痤疮及痤疮瘢痕的最新光电治疗；激光与微创美容手段联合面部年轻化；美容外科及光电治疗特殊病例展示，常见面部问题皮肤及各种光电术后的皮肤修护；激光治疗与美容术中常见问题和不良反应处理；医生、咨询师与求美者沟通技巧、美容心理学等内容，并就损美性皮肤病的中西医结合治疗、中西医结合抗衰新理念等发明的内容进行了深入讲解。</p>
			<p>
				<el-image
				  style="width: 100%;"
				  src="http://www.fulqun.com/uploadfile/2019/0902/20190902071136387.jpg"
				  fit="fill"
				></el-image>
			</p>
			<p style="font-size: 14px;text-indent: 2em;">
				本期学习班秉承继往“求新、务实、优质”的办班宗旨，多角度展现国内外激光美容医学新技术、新方法、新进展，为学员们提供了一个新技术学习与交流的平台。
			</p>
		</div>
		<div class="footer">
			<ul class="putbox">
				<li>© 北京安德普泰医疗科技有限公司 2021 All Rights Reserved.</li>
				<li>邮箱：demon211@sohu.com</li>
				<li>
					地址：北京市大兴区中关村科技园区大兴生物医药产业基地天华大街5号院13号楼11层1104室、1105
				</li>
				<li>
					<a href="https://beian.miit.gov.cn/">京ICP备18032874号-7</a>
				</li>
				<li>
					<a @click="go">互联网产品信息服务资格证书：（京）-非经营性-xxxx-xxxx号</a>
				</li>
			</ul>
			<div class="contactbox">
				<p>010-50846938</p>
				<p>周一至周五 9:00-17:30</p>
				<p>在线客服</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				images: [
				  "https://uplabimg.andupchain.com/%E5%AE%98%E7%BD%91/2d6dd2e5-2093-481b-82df-cd52161e40e5.png",
				],
			}
		},
		methods:{
			go() {
				this.$router.push('/certification')
			}
		}
	}
</script>

<style scoped>
	.footer {
		height: 200px;
		padding: 30px;
		background-color: rgb(250, 250, 250);
		display: flex;
		justify-content: space-between;
	}
	
	.putbox {
		list-style: none;
		font-size: 12px;
		width: 70%;
		margin-top: 10px;
		padding-left: 10%;
		line-height: 30px;
	}
	
	.putbox a {
		text-decoration: none;
		color: #666;
	}
	
	.contactbox {
		width: 30%;
		height: 100%;
		text-align: center;
		line-height: 50px;
	}
	
	.contactbox p:nth-child(1) {
		color: rgb(65, 110, 179);
		font-size: 28px;
	}
	
	.contactbox p:nth-child(2) {
		font-size: 14px;
		color: #666;
	}
	
	.contactbox p:nth-child(3) {
		width: 180px;
		height: 36px;
		margin: auto;
		border: 1px solid rgb(65, 110, 179);
		color: rgb(65, 110, 179);
		line-height: 36px;
		cursor: pointer;
	}
</style>
